import { render, staticRenderFns } from "./VConfirm.vue?vue&type=template&id=c2d09564"
import script from "./VConfirm.vue?vue&type=script&lang=ts"
export * from "./VConfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports